import { createReducer, on } from "@ngrx/store";
import { User } from "../../models/user";
import { addSuccessUserCompanyAct, setViolationsUserCompanyAct } from "./companies-user-actions";

const user: User = new User();

export const companiesUserReducer = createReducer(
    {
        user,
        violations: {},
        loading: false
    },
    on(addSuccessUserCompanyAct, (state, { userNew }) => ({
        user: { ...userNew },
        violations: {},
        loading: state.loading,
    })),
    on(setViolationsUserCompanyAct, (state, { userForm, violations }) => ({
        user: { ...userForm },
        violations: {...violations},
        loading: false,
    })),
);